import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import { config } from "vuex-module-decorators";
import { safeLocalStorage } from "@/lib/safeStorage";

Vue.use(Vuex);

// Set rawError to true by default on all @Action decorators
config.rawError = true;

// Reducer defines which state items are persistet in localstorage. The object returned by reducer is synced with localStorage.
const vuexLocal = new VuexPersistence({
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: state.userStore
    };
  }
});

const vuexLocalAttachmentResponse = new VuexPersistence({
  key: "attachmentResponse",
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: {
        _attachmentRequestToken: state.attachmentResponse?._attachmentRequestToken
      }
    };
  }
});

const vuexLocalFeature = new VuexPersistence({
  key: "feature",
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: state.feature
    };
  }
});

const vuexLocalFleetManager = new VuexPersistence({
  key: "fleetManagerStore",
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: state.fleetManagerStore
    };
  }
});

const vuexLocalBookingCreate = new VuexPersistence({
  key: "bookingCreateStore",
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: state.bookingCreateStore
    };
  }
});

const vuexLocalUi = new VuexPersistence({
  key: "ui",
  storage: safeLocalStorage,
  reducer: (state: any) => {
    return {
      state: state.ui
    };
  }
});

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  plugins: [
    vuexLocal.plugin,
    vuexLocalAttachmentResponse.plugin,
    vuexLocalFeature.plugin,
    vuexLocalFleetManager.plugin,
    vuexLocalUi.plugin,
    vuexLocalBookingCreate.plugin
  ]
});
